import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useFoodList() {
    const { t } = useI18nUtils()
    const isFoodFormSidebarActive = ref(false)
    const foodData = ref(null)
    const toast = useToast()
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const currentPage = ref(1)
    const searchQuery = ref('')
    const menus = ref([]);
    const catagoriesData = ref([])
    const parent = ref(0);
    const selected = ref("")
    const images = ref([])
    const folders = ref([])
    const statusFilter = ref(null)
    const catagoryFilter = ref(null)
    const totalCategories = ref(0)
    const refCatagoryListTable = ref(null)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const tableColumns = [
        { key: '', label: '', sortable: false },
        // { key: 'cover_image', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
        { key: 'name', label: 'Food Name', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'price', label: 'Price', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ]
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalCategories.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalCategories.value,
        }
    })

    store.dispatch('app-food/getFoodCategories', {
        site_id: getLocalSite.id
    })
        .then(response => {
            catagoriesData.value = response.data.data
    })

    const updateOrdering = () => {
        const filteredData = menus.value?.filter(item => item !== undefined);

        store.dispatch('app-food/updateOrdering', filteredData)
    }

    const resolveCatagoryStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveCatStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter, catagoryFilter], () => {
        fetchData()
    })

    const updateFood = (data) => {
        foodData.value = data
        isFoodFormSidebarActive.value = true
    }

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch(`app-food/getFood`, {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'ordering_count DESC',
            category_id: catagoryFilter.value,
            sites_id: getLocalSite.id
        })
            .then(response => {
                menus.value = response.data.data
                totalCategories.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error fetching Menu' list",
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                })
            })
    }

    const deleteData = (id) => {
        store.dispatch('app-food/deleteFood',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        isFoodFormSidebarActive,
        foodData,
        refetchData,
        fetchData,
        tableColumns,
        searchQuery,
        dataMeta,
        menus,
        t,
        resolveCatagoryStatusVariant,
        resolveCatStatusnameVariant,
        updateFood,
        selected,
        images,
        statusFilter,
        catagoryFilter,
        catagoriesData,
        totalCategories,
        perPage,
        perPageOptions,
        refCatagoryListTable,
        currentPage,
        deleteData,
        updateOrdering,
    }
}